import { useState } from "react";

import apiClient from "@/lib/api/client";

export const useHandleDownload = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = async (
    attachmentId: null | number,
    url: string | undefined,
    filename: string,
  ) => {
    setIsLoading(true);

    try {
      let href: string | undefined;

      if (attachmentId) {
        const { downloadUrl } = await apiClient
          .url(`/attachments/download/${attachmentId}`)
          .get()
          .json<{ downloadUrl: string }>();

        href = downloadUrl;
      } else {
        href = url;
      }

      if (!href) return;

      const a = document.createElement("a");

      a.href = href;
      a.download = filename;
      document.body.append(a);
      a.click();
      a.remove();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleDownload,
    isLoading,
  };
};
